<template>
  <div>
    <draggable
      v-bind="dragOptions"
      tag="div"
      class="widget-item-container mb-2"
      :list="list"
      :value="value"
      @input="inputEmit"
      @change="changeEmit"
      swapThreshold="1"
    >
      <v-card
        :key="option.id"
        v-for="option in realValue"
        class="d-flex justify-space-between align-center text-subtitle-2 mb-2 pl-1 px-3 py-2 grey--text text--darken-3"
      >
        <div>
          <v-icon class="option-drag-icon">mdi-drag</v-icon>
          {{option.name}}
        </div>
        <div>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :bind="attrs"
                v-on="on"
                small
                icon
                class="blue lighten-5 mr-1"
                @click="editOption(option.code)"
              >
                <v-icon size="15" color="blue">mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>Opsiyonu düzenle</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :bind="attrs"
                v-on="on"
                small
                icon
                class="grey lighten-3 mr-1"
                @click="$emit('input-list', option.sysname)"
              >
                <v-icon size="15" color="black">mdi-form-textbox</v-icon>
              </v-btn>
            </template>
            <span>Input listesini getir</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn :bind="attrs" v-on="on" small icon @click="deleteOptionDialog(option.code)">
                <v-icon size="15" color="red">mdi-delete</v-icon>
              </v-btn>
            </template>
            <span>Opsiyonu kaldır</span>
          </v-tooltip>
        </div>
      </v-card>
    </draggable>
    <edit-option v-model="editOptionData" />
    <v-dialog v-model="optionDelete.optionDeleteDialog" persistent max-width="500">
      <v-card>
        <v-card-title class="headline red--text text--darken-4">
          <v-icon left color="red darken-4">mdi-close-octagon</v-icon>Uyarı
        </v-card-title>
        <v-card-text>
          Bir opsiyonu sistemden kaldırdığınızda ona bağlı tüm input'ları da kaldırmış olursunuz.
          Kaldırılına inputlar opsiyon yeniden eklense de geri getirilemez.
          <br />Bu opsiyonu gerçekten
          <u>kaldırmak</u> istiyor musunuz ?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="optionDelete.optionDeleteDialog = false">İptal</v-btn>
          <v-btn
            color="green darken-1"
            text
            :loading="optionDelete.optionDeleteLoading"
            @click="deleteOption()"
          >Evet</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import EditOption from "./EditOption.vue";
import { mapState, mapGetters } from "vuex";

export default {
  name: "OptionsList",
  components: {
    draggable,
    EditOption
  },
  props: {
    value: {
      required: false,
      type: Array,
      default: null
    },
    list: {
      required: false,
      type: Array,
      default: null
    }
  },
  data: () => ({
    editOptionData: "",
    optionDelete: {
      optionDeleteDialog: false,
      optionDeleteLoading: false,
      optionDeleteCode: ""
    }
  }),
  computed: {
    dragOptions() {
      return {
        animation: 0,
        group: "widget",
        disabled: false,
        ghostClass: "ghost",
        put: () => true,
        pull: false
      };
    },
    realValue() {
      return this.value ? this.value : this.list;
    },
    ...mapState({
      activeOptionType: state => state.Option.optionType
    }),
    ...mapGetters({
      optionStore: "Option/optionStore"
    })
  },
  methods: {
    changeEmit(value) {
      this.$emit("change", value);
    },
    inputEmit(value) {
      this.$emit("input", value);
    },
    editOption(optionCode) {
      this.editOptionData = optionCode;
    },
    deleteOptionDialog(optionCode) {
      this.optionDelete.optionDeleteCode = optionCode;
      this.optionDelete.optionDeleteDialog = true;
    },
    deleteOption() {
      const optionCode = this.optionDelete.optionDeleteCode,
        { optionType, optionName } = this.activeOptionType;
      this.optionDelete.optionDeleteLoading = true;

      this.$store
        .dispatch(this.optionStore("deleteOption"), {
          optionCode,
          optionType,
          optionName
        })
        .then(res => {
          if (res.status === 200) {
            this.$snotify.success(
              "Opsiyon başarıyla sistemden kaldırılmıştır",
              this.$t('PANEL.NOTIFY.SUCCESS')
            );
            this.optionDelete.optionDeleteDialog = false;
            this.$emit("delete-option", optionCode);
          } else {
            this.$snotify.error(res.data.errMessage, this.$t('PANEL.NOTIFY.ERROR'));
          }
          this.optionDelete.optionDeleteLoading = false;
        });
    }
  }
};
</script>

<style>
.option-drag-icon {
  cursor: grab;
  margin-right: 0.1em;
}

.button {
  margin-top: 35px;
}
.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
.list-group {
  min-height: 20px;
}
.list-group-item {
  cursor: move;
}
.list-group-item i {
  cursor: pointer;
}
</style>